import { FormField, getErrors, RichTextEditor } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps } from 'react';

type Props = {
  // onSubmit:()=>
  isDisabled?: boolean;
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function RichtTextEditorField(props: Props) {
  const { isDisabled, ...rest } = props;
  const field = useFieldContext<{ markdown: string; files: Array<File> }>();

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      wrapperField="div"
      inputSlot={
        <RichTextEditor
          onChange={(markdown) =>
            field.handleChange({
              markdown,
              files: field.state.value.files,
            })
          }
          onChangeFiles={(files) =>
            field.handleChange({
              markdown: field.state.value.markdown,
              files,
            })
          }
          isDisabled={isDisabled}
          isSubmitForForm={true}
          contentClassname="max-h-[250px] overflow-y-auto"
        />
      }
    />
  );
}
